import htmlTemplate from "../../assets/images/html_template.png";
import verticalTemplate from "../../assets/images/vertical_template.png";
import verticalTemplate21cm from "../../assets/images/vertical_template_21cm.png";

// PRESCRIPTION TEMPLATES
export const prescriptionTemplates = [
  { label: "A4 (210 x 297 mm)", value: "Prescription" },
  { label: "A5 (148 x 210 mm)", value: "PrescriptionA5" },
];

export const BIllING_TEMPLATE = [
  { consumerId: 0, label: 'A4 (210 x 297 mm)', value: 'BillingInvoiceA4' },
  { consumerId: 0, label: 'A5 (148 x 210 mm)', value: 'BillingInvoiceA5' },
  { consumerId: 0, label: 'A4 HTML', value: 'BillingInvoiceA4HTML' },
]

// PRESCRIPTION REPORTS
export const PRESCRIPTION_REPORT_TEMPLATES = [
  {
    label: "HTML",
    value: "Prescription",
    thumbnail: htmlTemplate,
  },
  {
    label: "Vertical Template",
    value: "Vertical",
    thumbnail: verticalTemplate,
  },
];

export const PRESCRIPTION_REPORT_TEMPLATES_44 = [
  {
    label: "HTML",
    value: "Prescription",
    thumbnail: htmlTemplate,
  },
  {
    label: "Vertical Template (100%)",
    value: "Vertical100%",
    thumbnail: verticalTemplate,
  },
  {
    label: "Vertical Template (21cm)",
    value: "Vertical21cm",
    thumbnail: verticalTemplate21cm,
  },
];